var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcShare = function SvgIcShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "25px",
    viewBox: "0 0 22 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_share")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_share",
    fill: "#31549B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.29,7.88 C15.1139981,7.88 13.35,6.11600191 13.35,3.94 C13.35,1.76399809 15.1139981,-9.32542563e-16 17.29,-1.33226763e-15 C19.4660019,-1.7319927e-15 21.23,1.76399809 21.23,3.94 C21.23,4.98495297 20.814894,5.98710739 20.0760007,6.72600072 C19.3371074,7.46489405 18.334953,7.88 17.29,7.88 Z M17.29,2 C16.2185676,2 15.35,2.86856759 15.35,3.94 C15.35,5.01143241 16.2185676,5.88 17.29,5.88 C18.3614324,5.88 19.23,5.01143241 19.23,3.94 C19.23,3.42548001 19.0256077,2.93203342 18.6617872,2.56821284 C18.2979666,2.20439227 17.80452,2 17.29,2 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94,16.07 C1.76399809,16.07 -1.06578425e-15,14.3060019 -1.33226763e-15,12.13 C-1.59875101e-15,9.95399809 1.76399809,8.19 3.94,8.19 C6.11600191,8.19 7.88,9.95399809 7.88,12.13 C7.87450384,14.3037213 6.11372126,16.0645038 3.94,16.07 Z M3.94,10.19 C2.86856759,10.19 2,11.0585676 2,12.13 C2,13.2014324 2.86856759,14.07 3.94,14.07 C5.01143241,14.07 5.88,13.2014324 5.88,12.13 C5.88,11.61548 5.67560773,11.1220334 5.31178716,10.7582128 C4.94796658,10.3943923 4.45451999,10.19 3.94,10.19 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.29,24.45 C15.1139981,24.45 13.35,22.6860019 13.35,20.51 C13.35,18.3339981 15.1139981,16.57 17.29,16.57 C19.4660019,16.57 21.23,18.3339981 21.23,20.51 C21.23,21.554953 20.814894,22.5571074 20.0760007,23.2960007 C19.3371074,24.034894 18.334953,24.45 17.29,24.45 Z M17.29,18.57 C16.2185676,18.57 15.35,19.4385676 15.35,20.51 C15.35,21.5814324 16.2185676,22.45 17.29,22.45 C18.3614324,22.45 19.23,21.5814324 19.23,20.51 C19.23,19.99548 19.0256077,19.5020334 18.6617872,19.1382128 C18.2979666,18.7743923 17.80452,18.57 17.29,18.57 L17.29,18.57 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(10.609605, 16.347015) rotate(-57.780000) translate(-10.609605, -16.347015) ",
    x: 9.60960532,
    y: 11.3920148,
    width: 2,
    height: 9.91
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(10.590674, 8.057718) rotate(-30.130000) translate(-10.590674, -8.057718) ",
    x: 5.69567412,
    y: 7.05771767,
    width: 9.79,
    height: 2
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_share.398091b8.svg";
export { ForwardRef as ReactComponent };